module.exports = __webpack_public_path__ + "img/zimmer-frei-2.c5be6b25.jpg";